var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_59_213",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 112,
    height: 112
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H112V112H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_59_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0008 -0.00195312C86.9282 -0.00195312 112.002 25.0716 112.002 56.0008C112.002 86.9282 86.9282 112.002 56.0008 112.002C25.0716 112.002 -0.00195312 86.9282 -0.00195312 56.0008C-0.00195312 25.0716 25.0716 -0.00195312 56.0008 -0.00195312ZM32.9221 80.099H40.815V48.8293H32.9221V80.099ZM57.5669 63.6195C57.5669 58.6876 59.8911 54.7329 65.2444 54.7329C70.5278 54.7329 72.2393 58.9931 72.2393 63.6195V80.1027H80.0843V59.9574C80.0843 52.8006 76.6191 47.7969 69.0593 47.7969C65.629 47.7969 61.6651 49.5949 59.9887 52.7178L57.5669 57.1363V48.8293H50.0973V80.099H57.5669V63.6195ZM60.1506 63.6195V82.6827H47.5135V46.2438H60.1506V48.5717C62.646 46.3358 65.71 45.2114 69.0593 45.2114C78.0453 45.2114 82.6698 51.3689 82.6698 59.9574V82.6772L69.6555 82.679V63.6195C69.6555 60.5131 68.971 57.3184 65.2444 57.3184C61.3578 57.3184 60.1506 60.1451 60.1506 63.6195ZM36.8198 41.8124C39.5544 41.8124 41.7241 39.5765 41.7241 36.8566C41.7241 34.1349 39.5544 31.9026 36.8198 31.9026C34.0833 31.9026 31.9155 34.1349 31.9155 36.8566C31.9155 39.5765 34.0815 41.8124 36.8198 41.8124ZM36.8198 44.398C32.6682 44.398 29.3299 40.9935 29.3299 36.8566C29.3299 32.7215 32.6682 29.3171 36.8198 29.3171C40.9677 29.3171 44.3078 32.7215 44.3078 36.8566C44.3078 40.9898 40.9677 44.398 36.8198 44.398ZM30.3366 82.6827V46.2438H43.3987V82.6827H30.3366ZM56.0008 2.58545C26.4996 2.58545 2.58177 26.4996 2.58177 56.0008C2.58177 85.502 26.4996 109.416 56.0008 109.416C85.502 109.416 109.418 85.502 109.418 56.0008C109.418 26.4996 85.502 2.58545 56.0008 2.58545Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.1c8cf8a1ead5a90d064c073e416637d1.svg";
export { ForwardRef as ReactComponent };